export const addHttpsImagePath = url => {
  return url && (url.includes('https') ? url : url.replace('http', 'https'));
};
